import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';

const messages = defineMessages({
  not_saved_yet: {
    id: 'Not saved yet',
    defaultMessage: 'Not saved yet',
  },
  published: {
    id: 'Published',
    defaultMessage: 'Published',
  },
  created: {
    id: 'Created',
    defaultMessage: 'Created',
  },
  modified: {
    id: 'Modified',
    defaultMessage: 'Modified',
  },
  private: {
    id: 'Private',
    defaultMessage: 'Private',
  },
  pending: {
    id: 'Pending',
    defaultMessage: 'Pending',
  },
  not_published_yet: {
    id: 'Not published yet',
    defaultMessage: 'Not published yet',
  },
  published_on: {
    id: 'Published on',
    defaultMessage: 'Published on',
  },
});

const DateInfo = ({
  properties,
  intl,
  className = '',
  hideModifiedDate = false,
  hidePublishedLabel = false,
  hideReviewState = false,
}) => {
  moment.locale(toBackendLang(intl.locale));

  const { created, modified, effective, review_state } = properties;

  const createdDate = created ? moment(created) : null;
  const effectiveDate = effective ? moment(effective) : null;

  const displayDate = effectiveDate || createdDate;

  const modifiedDate =
    modified && !moment(modified).isSame(displayDate) ? moment(modified) : null;

  if (!createdDate) {
    return (
      <span className={`date-info ${className}`}>
        <span className="new">
          {intl.formatMessage(messages.not_saved_yet)}
        </span>
      </span>
    );
  }

  function renderReviewState() {
    if (hideReviewState) {
      return null;
    }

    if (effectiveDate && review_state !== 'published') {
      return (
        <span className="private">
          {intl.formatMessage(messages[review_state])}
        </span>
      );
    }
    if (!effectiveDate && review_state) {
      return (
        <span className="private">
          {intl.formatMessage(messages.not_published_yet)}
        </span>
      );
    }
  }

  return (
    <div className={`date-info ${className}`}>
      {!hidePublishedLabel && effectiveDate && (
        <span className="published-on">{`${intl.formatMessage(messages.published_on)} `}</span>
      )}
      {moment(displayDate).format('lll')}
      {!hideModifiedDate &&
        modifiedDate &&
        ` - ${intl.formatMessage(messages.modified)} ${moment(
          modified,
        ).fromNow()}`}

      {renderReviewState()}
    </div>
  );
};

DateInfo.propTypes = {
  properties: PropTypes.shape({
    created: PropTypes.string,
    modified: PropTypes.string,
    effective: PropTypes.string,
    review_state: PropTypes.string,
  }),
  className: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(DateInfo);
